import {
  Stack,
  IconButton,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { colors } from "../Theme";

const CustomPagination = ({
  page,          // 0-based
  limit,
  hasMore,
  onPageChange,  // (newPage: number)
  onLimitChange, // (newLimit: number)
  start,
  end,
  limitOptions = [5, 10, 25],
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      mt={4}
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={1.5}
    >
      {/* Row 1: navigation controls */}
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={isMobile ? 0.5 : 2}
        flexWrap="nowrap"
      >
        <IconButton
          onClick={() => onPageChange(0)}
          disabled={page === 0}
          size={isMobile ? "small" : "medium"}
        >
          <FirstPageIcon fontSize={isMobile ? "small" : "medium"} />
        </IconButton>

        <Pagination
          page={page + 1}
          count={hasMore ? page + 2 : page + 1}
          onChange={(e, value) => onPageChange(value - 1)}
          color="primary"
          size={isMobile ? "small" : "medium"}
          siblingCount={isMobile ? 0 : 1}
          boundaryCount={1}
          sx={{
            '& .MuiPaginationItem-root.Mui-selected': {
              backgroundColor: colors.primary.main,
              color: colors.primary.contrastText,
              '&:hover': {
                backgroundColor: colors.primary.main,
              },
            },
          }}
        />

        <IconButton
          onClick={() => onPageChange(page + 1)}
          disabled={!hasMore}
          size={isMobile ? "small" : "medium"}
        >
          <LastPageIcon fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
      </Stack>

      {/* Row 2: limit selector + showing text */}
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={isMobile ? 2 : 4}
        flexWrap="wrap"
      >
        <FormControl size="small">
          <InputLabel>Limit</InputLabel>
          <Select
            value={limit}
            label="Limit"
            onChange={(e) => onLimitChange(e.target.value)}
            sx={{ minWidth: 80 }}
          >
            {limitOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography
          variant="body2"
          sx={{ textAlign: "center", whiteSpace: "nowrap" }}
        >
          Showing {start}–{end}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default CustomPagination;